/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { Spinner } from './styles'

export default function Input(props) {
  const { value, loading, ...rest } = props

  return (
    <div>
      <TextField {...rest} value={value || ''} />
      { loading ? <Spinner size={16} color="inherit" /> : null }
    </div>
  )
}

Input.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  loading: PropTypes.bool,
}

Input.defaultProps = {
  value: '',
  loading: false,
}
